import { Button, DatePicker, Modal } from '@components/common';
import { FormTextarea } from '@components/common/FormField';
import React, { useState } from 'react';
import { JournalEntryRecord } from '../../../../types/accounting';

interface ReverseJournalEntryModalProps {
  entry: JournalEntryRecord;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (values: { reversalDate: string; memo: string }) => void;
}

export function ReverseJournalEntryModal({
  entry,
  isSubmitting,
  onClose,
  onSubmit,
}: ReverseJournalEntryModalProps) {
  const [reversalDate, setReversalDate] = useState(
    new Date().toISOString().slice(0, 10),
  );
  const [memo, setMemo] = useState(
    entry.memo ? `Reversal of: ${entry.memo}` : 'Reversal entry',
  );

  return (
    <Modal isOpen onClose={onClose} title="Reverse journal entry" size="md">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit({ reversalDate, memo });
        }}
        className="space-y-3"
      >
        <div className="rounded-2xl border border-pos-primary/20 bg-pos-primary/8 px-4 py-3 text-sm text-gray-700">
          This will create and post an equal opposite journal entry for the
          selected transaction.
        </div>

        <DatePicker
          label="Reversal date"
          mode="single"
          value={reversalDate}
          onChange={setReversalDate}
          placeholder="Select reversal date"
        />

        <FormTextarea
          label="Reversal memo"
          required
          value={memo}
          onChange={(event) => setMemo(event.target.value)}
          rows={3}
          placeholder="Why are you reversing this entry?"
        />

        <div className="flex justify-end gap-2 border-t border-gray-100 pt-3">
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button type="submit" isLoading={isSubmitting}>
            Reverse entry
          </Button>
        </div>
      </form>
    </Modal>
  );
}
